/**
 * @param {string} hex
 */
function hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}

/**
 * @param {number} r
 * @param {number} g
 * @param {number} b
 */
function rgbToHex(r, g, b) {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

/**
 * @param {string} startHex
 * @param {string} endHex
 * @param {number} level
 */
export function gradientHex(startHex, endHex, level) {
    const start = hexToRgb(startHex);
    const end = hexToRgb(endHex);
    const r = Math.round(start.r + (end.r - start.r) * Math.max(0, Math.min(1, level)));
    const g = Math.round(start.g + (end.g - start.g) * Math.max(0, Math.min(1, level)));
    const b = Math.round(start.b + (end.b - start.b) * Math.max(0, Math.min(1, level)));
    return rgbToHex(r, g, b);
}
